import { VibrationType } from "../types/vibration.types";
import { colors, alphaVar } from "../../../../ui/colors";

export const getVibrationAnimation = (mode: VibrationType, speed: number) => {
  const animationMap = {
    vibrate: {
      '@keyframes vibrate': {
        '0%': { transform: 'translateX(0)' },
        '10%': { transform: 'translateX(-3px)' },
        '20%': { transform: 'translateX(3px)' },
        '30%': { transform: 'translateX(-3px)' },
        '40%': { transform: 'translateX(3px)' },
        '50%': { transform: 'translateX(0)' },
        '100%': { transform: 'translateX(0)' },
      },
      animation: `vibrate ${speed}ms ease-in-out infinite`,
    },
    pulse: {
      '@keyframes pulse': {
        '0%': { transform: 'scale(1)', opacity: 1 },
        '50%': { transform: 'scale(1.02)', opacity: 0.9 },
        '100%': { transform: 'scale(1)', opacity: 1 },
      },
      animation: `pulse ${speed}ms ease-in-out infinite`,
    },
    glow: {
      '@keyframes glow': {
        '0%, 100%': {
          boxShadow: `0 4px 16px ${alphaVar('#000000', 0.08)}`,
        },
        '50%': {
          boxShadow: `0 4px 24px ${alphaVar(colors.orange.base, 0.3)}`,
        },
      },
      animation: `glow ${speed}ms ease-in-out infinite`,
    },
    shake: {
      '@keyframes shake': {
        '0%': { transform: 'translateX(0) rotate(0deg)' },
        '25%': { transform: 'translateX(-4px) rotate(-0.5deg)' },
        '50%': { transform: 'translateX(4px) rotate(0.5deg)' },
        '75%': { transform: 'translateX(-4px) rotate(-0.5deg)' },
        '100%': { transform: 'translateX(0) rotate(0deg)' },
      },
      animation: `shake ${speed}ms ease-in-out infinite`,
    },
    bounce: {
      '@keyframes bounce': {
        '0%': { transform: 'translateY(0)' },
        '25%': { transform: 'translateY(-4px)' },
        '50%': { transform: 'translateY(0)' },
        '75%': { transform: 'translateY(-2px)' },
        '100%': { transform: 'translateY(0)' },
      },
      animation: `bounce ${speed}ms ease-in-out infinite`,
    },
    none: {
      animation: 'none',
    },
  };

  return animationMap[mode] || animationMap.vibrate;
};
